module.exports = {"530828101":"勐朗镇","530828102":"上允镇","530828103":"糯扎渡镇","530828104":"惠民镇","530828105":"东回镇","530828201":"发展河哈尼族乡","530828202":"谦六彝族乡","530828203":"糯福乡","530828204":"东河乡","530828205":"大山乡","530828206":"南岭乡","530828207":"雪林佤族乡","530828208":"木戛乡","530828209":"酒井哈尼族乡","530828212":"拉巴乡","530828213":"竹塘乡","530828214":"富邦乡","530828215":"安康佤族乡","530828216":"文东佤族乡","530828217":"富东乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530828.json
// module id = 2413
// module chunks = 0